<template>
    <div ref="rows" class="graph-row" style="position: relative;">
        <div ref="cells" class="table-cell" :class="{ weekend: isWeekend(date.date), 'hidden-date' : !date.shown }" :style="{ width: cell_width + 'px' }" v-for="(date, key) in dates" :key="key">
            <div ref="marker" class="marker" v-if="compareDate(date.date, item.start_date, item)" :data-cell-id="key + 1" :data-row-id="item.id" :data-parent-id="item.parentId" :class="{ parent : item.isParent }" :style="{ width: Math.min(cell_width * item.duration, (dates.length - key) * cell_width) + 'px' }" @mousedown.left="handleMouseDown">

                <div v-if="user && item.user && !item.isParent" class="marker-user">
                    <img :src="item.user[user.image]">
                </div>

                <div v-if="item.proportion" class="marker-proportion" :class="{ completed : item.proportion > 96 }" :style="{ width: + item.proportion + '%'}"></div>

                <div class="tooltip">
					<div class="gantt-message-overlay">
						<div class="gantt-message-message">
							<div class="title">{{ item.summary || item.name }}</div>
							Start Time: {{ item.start_date | moment('YYYY-MM-DD HH:mm:ss') }}<br>
							End: {{ item.end_date | moment('YYYY-MM-DD HH:mm:ss') }}<br>
							Duration: {{ item.duration }} {{ granularity }}<br>
							Proportion: {{ item.proportion || 0 }}%
						</div>
					</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	props: {
		/**
		 * Object to define the row
		 * @default {}
		 * @type {Object}
		 */
		item: {
			type: Object,
			default: () => {
				return {}
			}
		},
		/**
		 * String to define the granularity of the chart
		 * @default 'day'
		 * @type {String}
		 */
		granularity: {
			type: String,
			default: 'day'
		},
		/**
		 * String to define the cell dates
		 * @default []
		 * @type {Object}
		 */
		dates: {
			type: Array,
			default: () => {
				return []
			}
		},

		/**
		 * Number that defines the cell width
		 * @default 0
		 * @type {Number}
		 */
		cell_width: {
			type: Number,
			default: 0
		},

		/**
		 * Object to reflect the user object
		 * Or boolean to indicate no user object
		 * @default 'true | {}'
		 * @type {Boolean, Object}
		 */
		user: {
			type: [Boolean, Object],
			default: () => {
				return {
					id: 'id',
					image: 'src'
				}
			}
		},

		/**
		 * Boolean defines if the task is opened
		 * @default true
		 * @type {Boolean}
		 */
		open: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		/*
        | Compare if item start time falls within this timeline cell
        */
		compareDate(cellDate, itemStartDate, item) {
			const cellMoment = this.$moment(cellDate)
			const itemMoment = this.$moment(itemStartDate)
			
			// Check if this is the cell where the item should start
			// by comparing if item start time is >= cell time and < next cell time
			const cellIndex = this.dates.findIndex(d => d.date === cellDate)
			if (cellIndex === -1) return false
			
			const nextCell = this.dates[cellIndex + 1]
			if (!nextCell) {
				// Last cell - check if item starts at or after this cell
				return itemMoment.isSameOrAfter(cellMoment)
			}
			
			const nextCellMoment = this.$moment(nextCell.date)
			return itemMoment.isSameOrAfter(cellMoment) && itemMoment.isBefore(nextCellMoment)
		},

		/*
        | Compare 2 given dates 
        */
		isWeekend(date) {
            let day = new Date(date).getDay()
			return day === 6 || day === 0
		},

		/*
        | Handle when a marker has been clicked
        */
		handleMouseDown(e) {
			e.preventDefault()
			if (!this.open) {
				let self = this
				this.$emit('open')
				this.$nextTick().then(() => {
					self.handleMouseDown(e)
				})
			}

			window.markers = []

			// Create a marker object
			// And add it to our marker list
			let target = e.target
			let offset = target.offsetLeft
			let marker = this.createMarker(target, e, offset)
			marker.recursive = false
			window.markers.push(marker)

			// Get all assicated marker childs
			// And add them to the marker list
			let elements = document.querySelectorAll('[data-parent-id="' + this.item.id + '"]')
			elements.forEach(el => {
				marker = this.createMarker(el, e, offset)
				window.markers.push(marker)
			})
		},

		/*
        | Create a marker element,
        | and add it's current x position
        */
		createMarker(el, e, offset) {
			let marker = el
			marker.lastCell = marker.dataset.cellId
			marker.parentId = marker.dataset.parentId
			marker.offset = marker.offsetLeft - offset
			marker.recursive = true
			marker.classList.add('selected')

			return marker
		}
	}
}
</script>
<style lang="scss" scoped>
.gantt-message-overlay {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.1);
	display: flex;
    cursor: pointer;
    z-index: 1;
	.gantt-message-message {
		width: 300px;
		height: auto;
		background: #fff;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		margin: auto;
		padding: 15px;
		color: #464957;
		.title {
			font-size: 14px;
			font-weight: 700;
			margin-bottom: 5px;
		}
		.description {
			font-size: 13px;
		}
	}
}
.marker:hover .tooltip {
	opacity: 1;
}
</style>